import { createFileRoute } from "@tanstack/react-router";
import LandingSectionPage from "@/pages/LandingSectionPage";
import { landingHead } from "@/lib/landingHead";

export const Route = createFileRoute("/en/ai-agent")({
  head: () => landingHead("aiAgent", "en"),
  component: () => <LandingSectionPage section="aiAgent" routeLang="en" />,
  errorComponent: () => <LandingSectionPage section="aiAgent" routeLang="en" />,
  notFoundComponent: () => <LandingSectionPage section="aiAgent" routeLang="en" />,
});
